import { render } from "./CreatorCreditCounter.vue?vue&type=template&id=95aec5e4"
import script from "./CreatorCreditCounter.vue?vue&type=script&lang=js"
export * from "./CreatorCreditCounter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/CreatorCreditCounter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "95aec5e4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('95aec5e4', __exports__)) {
    api.reload('95aec5e4', __exports__)
  }
  
  module.hot.accept("./CreatorCreditCounter.vue?vue&type=template&id=95aec5e4", () => {
    api.rerender('95aec5e4', render)
  })

}


export default __exports__